<script setup lang="ts">
import { computed } from 'vue';
import { useOrderEditStore } from '@/stores/orderEdit';
import type { EditOutcome } from '@/stores/orderEdit';
import { useEditTexts } from '@/composables/useEditTexts';
import type { EditTextKey } from '@/composables/useEditTexts';

// The result of a submit, or of the poll after Stripe's success URL. Shared
// by the edit page and the dish-page block.
const store = useOrderEditStore();
const t = useEditTexts();

const OUTCOME_TEXT: Record<EditOutcome, EditTextKey> = {
  applied: 'edit_status_applied',
  processing: 'edit_status_processing',
  paid_pending: 'edit_status_paid',
  needs_attention: 'edit_status_attention',
  modification_pending: 'edit_modification_pending',
  payment_in_progress: 'edit_payment_in_progress',
};

const state = computed(() => (store.polling ? 'checking' : store.outcome));
const text = computed(() => {
  if (store.polling) return t.edit_status_checking;
  return store.outcome ? t[OUTCOME_TEXT[store.outcome]] : null;
});
</script>

<template>
  <p
    v-if="text"
    class="edit-outcome"
    :class="`edit-outcome--${state}`"
    role="status"
    data-testid="order-edit-outcome"
    :data-outcome="state"
  >
    {{ text }}
  </p>
</template>

<style scoped>
.edit-outcome {
  margin: 12px 0;
  padding: 12px 16px;
  border-radius: 6px;
  background: #eef6ee;
  color: #1b5e20;
}

.edit-outcome--modification_pending,
.edit-outcome--needs_attention {
  background: #fff4e5;
  color: #8a4b00;
}
</style>
